import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {AppTeam} from '@shared/models/team';
import {AppLeague} from '@shared/models/league';
import {State} from '@core/services/state';
import {LinkService} from '@core/services/link.service';

@Component({
  selector: 'app-search-cell',
  templateUrl: './search-cell.component.html',
  styleUrls: [
    './search-cell.component.scss',
    './search-cell-onHomeFav.component.scss'
  ]
})
export class SearchCellComponent implements OnInit {

  @Input() styleMode;
  @Input() state: State;
  @Input() team: AppTeam;
  @Input() league: AppLeague;
  @Input() filter: boolean = false;
  @Input() custom: {name: string, image: string} = null;
  @Input() @HostBinding('class.small-margin') public smallMargin = false;
  routerLink: String;
  link: String;

  constructor() { }

  ngOnInit() {
    if (this.team) {
      this.link = LinkService.getTeamLink(this.team.readable_id)
    } else if (this.league) {
      if (this.league.has_subleagues !== true) {
        this.link = LinkService.getLeagueLink(this.league.readable_id);
      }
    }
  }
}
